import { createSlice } from "@reduxjs/toolkit";

const initialState = {
		products: [],
		additionalServices: [],
		date: "",
		period: "",
		form: {
			id: 0,
			name: "",
			firstName: "",
			lastName: "",
			email: "",
			obs: "",
			local: "",
			date: "",
			period: "",
			zipCode: "",
			address: "",
			number: "",
			complement: "",
			neigh: "",
			city: "",
			state: "",
			responsible: "",
			reference: "",
			doc: "",
			phone: "",
		},
	};

const cartSlice = createSlice({
	name: "cart",
	initialState:initialState,
	reducers: {
		restart: (state, action) => {
			return initialState;
		},
		addProduct: (state, action) => {
			const { id, quantity } = action.payload;
			const existingProductIndex = state.products.findIndex(
				(product) => product.id === id
			);

			if (existingProductIndex !== -1) {
				state.products[existingProductIndex].quantity += quantity;
			} else {
				state.products.push(action.payload);
			}
		},
		removeProduct: (state, action) => {
			const { id } = action.payload;
			const existingProductIndex = state.products.findIndex(
				(product) => product.id === id
			);

			if (existingProductIndex !== -1) {
				state.products.splice(existingProductIndex, 1);
			}
		},
		addDate: (state, action) => {
			state.date = action.payload.date;
		},
		addPeriod: (state, action) => {
			state.period = action.payload.period;
		},
		addServices: (state, action) => {
			state.additionalServices = action.payload;
		},
		removeService: (state, action) => {
			const { id } = action.payload;
			const existingAdditionalServiceIndex = state.additionalServices.findIndex(
				(additionalService) => additionalService.value === id
			);

			if (existingAdditionalServiceIndex !== -1) {
				state.additionalServices.splice(existingAdditionalServiceIndex, 1);
			}
		},
		addFormField: (state, action) => {
			state.form[action.payload.id] = action.payload.value;
		},
	},
});

export const {
	addProduct,
	addDate,
	addPeriod,
	removeProduct,
	removeAdditionalService,
	addServices,
	removeService,
	addFormField,
	restart,
} = cartSlice.actions;
export default cartSlice.reducer;
